/* eslint-disable no-useless-escape */
export const EMAIL_PATTERN =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

const PASSWORD_PATTERN = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,16})/;

export const STARTS_WITH_NUMBER_PATTERN = /^\d+/;

export const STARTS_WITH_NUMBER_OR_LETTER_PATTERN = /^\w+/;

export const ONLY_NUMERIC_WITHOUT_ZERO_INPUT = /^(?:[1-9]\d*|0(?!(?:(\.|\,)0+)?$))?(?:(\.|\,)\d+)?$/;

export const EMAIL_VALIDATION = {
  value: EMAIL_PATTERN,
  message: "Enter a valid e-mail address.",
};
export const REQUIRED_VALIDATION = {
  value: true,
  message: "This field is required.",
};
export const PASSWORD_VALIDATION = {
  value: PASSWORD_PATTERN,
  message:
    "Passwords must be minimum eight characters with at least one lowercase and one uppercase letter and one number.",
};
export const ONLY_NUMERIC_WITHOUT_ZERO_INPUT_VALIDATION = {
  value: ONLY_NUMERIC_WITHOUT_ZERO_INPUT,
  message: "Enter a valid order value.",
};
